import { useEffect, useState } from "react";
export function useSlider() {
    var _a = useState(null), slider = _a[0], setSlider = _a[1];
    useEffect(function () {
        import(/* webpackChunkName: "zza.react-slick" */ "react-slick").then(function (exportObject) { return setSlider(function () { return exportObject.default; }); });
    }, []);
    return slider;
}
